export default __webpack_public_path__ + "static/media/img--LUX-kitchen-1.ed64d856.jpg";